import {Component, OnInit} from '@angular/core';
import {UserCardService} from "../service/user-card.service";
import {UserCardResponse} from "../interface/userCardResponse";
import {ImageType} from "../enums/image-type-enum";
import {ActivatedRoute, Router} from "@angular/router";
import {ENGLISH_ROUTES_FOR_PLACEHOLDER} from "../constants/global.constants";

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent {

  searchQuery: string = '';
  searchResults: UserCardResponse[] = [];
  searching: boolean = false;
  searchTimeout: any;
  currentPage: number = 0;
  pageSize: number = 10;
  noMoreResults: boolean = false;

  protected readonly ImageType = ImageType;

  constructor(
    private userCardService: UserCardService,
    private router: Router,
  ) {
  }

  checkUserProfileRouteLanguage(): boolean {
    return ENGLISH_ROUTES_FOR_PLACEHOLDER.some(route => this.router.url.includes(route));
  }

  search(): void {
    const trimmedQuery = this.searchQuery.trim();
    if (trimmedQuery.length >= 2) {
      this.searching = true;
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.currentPage = 0;
        this.userCardService.searchUserCards(trimmedQuery, this.currentPage, this.pageSize).subscribe(
          (results: UserCardResponse[]) => {
            this.searchResults = results;
            this.searching = false;
            this.noMoreResults = results.length < this.pageSize;
          }
        );
      }, 1000);
    } else {
      this.searchResults = [];
      this.searching = false;
      clearTimeout(this.searchTimeout);
    }
  }

  loadMore(): void {
    if (this.searchQuery.length >= 2) {
      this.currentPage++;
      this.userCardService.searchUserCards(this.searchQuery, this.currentPage, this.pageSize).subscribe(
        (newResults: UserCardResponse[]) => {
          this.searchResults = this.searchResults.concat(newResults);
          this.searching = false;
          this.noMoreResults = newResults.length < this.pageSize;
        }
      );
    }
  }

  clearSearchQuery(): void {
    this.searchQuery = '';
    this.searchResults = [];
    this.searching = false;
  }

  getUserCardImage(id: bigint, type: ImageType) {
    return this.userCardService.getCardImage(id, type);
  }
}
